// The phone's saved "available" choice and cross-tab channel, kept apart from
// TwilioDeviceService so main.js can end the phone session on an expired login
// without constructing the Twilio service at boot.
import { z } from 'zod'
import { BrowserStore } from '@/utils/BrowserStore'

export const PHONE_STATUS_CHANNEL = 'twilio-phone-status'

export const phoneAvailabilityStore = new BrowserStore(
  'twilioPhoneAvailability',
  z.object({ available: z.boolean().default(false) }),
)

/** Logged out: forget the saved choice and tell every open tab to unregister. */
export function endPhoneSession() {
  phoneAvailabilityStore.save({ available: false })
  const channel = new BroadcastChannel(PHONE_STATUS_CHANNEL)
  channel.postMessage({ type: 'intent', available: false })
  channel.close()
}
